import type { ApiErrorPayload } from '@/types'

export interface NormalizedError {
  title: string
  message: string
  field?: string
  code?: string
}

export const normalizeApiError = (payload?: ApiErrorPayload | null): NormalizedError[] => {
  if (!payload || !Array.isArray(payload.errors)) {
    return [
      {
        title: 'Error',
        message: 'Ocurrió un error inesperado. Intenta nuevamente.',
      },
    ]
  }

  return payload.errors.map((item) => ({
    title: item.code || 'Error',
    message: item.detail || 'Ocurrió un error inesperado.',
    field: item.field,
    code: item.code,
  }))
}
